import { IExecutionOptions } from '@kurtosys/types/query/IExecutionOptions.js';
import { IQueryOptionsFundManager } from '@kurtosys/types/query/options/IQueryOptionsFundManager.js';

import { getValueFromStringNotation } from '../../common/commonUtils/object.js';

import { BaseQuery } from './base/BaseQuery.js';

export class FundManagerQuery extends BaseQuery<IQueryOptionsFundManager> {
	initialize(executionOptions: IExecutionOptions): void {
		this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
		this.fillKeyFromQuery('extendedKey', 'extendedKeyQuery', executionOptions);
	}
	getOptions(): IQueryOptionsFundManager {
		const { key, keyQuery, extendedKey, options = {} } = this.queryOptions;
		return {
			key,
			keyQuery,
			extendedKey,
			...(options.fundManager || {}),
		};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const { key, extendedKey } = this.options;
		const fundManager = this.getFundManager(executionOptions);
		if (fundManager) {
			if (key) {
				const { biography: biographies } = fundManager;
				if (key === 'biography' && biographies) {
					const { culture, fallbackCulture } = executionOptions;
					let biographyItem = biographies.find((biography): boolean => biography.culture === culture);
					if (!biographyItem) {
						biographyItem = biographies.find((biography): boolean => biography.culture === fallbackCulture);
					}
					return (biographyItem && biographyItem.biography) as any;
				}
				if (key === 'extended') {
					const extended = extendedKey && fundManager.extended && getValueFromStringNotation(extendedKey, fundManager.extended);
					return (extended && extended.value) || extended;
				}
				return fundManager[key];
			}
			return fundManager as any;
		}
		return;
	}
}
